import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M5.99935 0.166016C2.7769 0.166016 0.166016 2.80042 0.166016 5.99935C0.166016 9.2218 2.7769 11.8327 5.99935 11.8327C9.19827 11.8327 11.8327 9.2218 11.8327 5.99935C11.8327 2.80042 9.19827 0.166016 5.99935 0.166016ZM5.99935 10.7036C3.38846 10.7036 1.29505 8.61024 1.29505 5.99935C1.29505 3.41198 3.38846 1.29505 5.99935 1.29505C8.58671 1.29505 10.7036 3.41198 10.7036 5.99935C10.7036 8.61024 8.58671 10.7036 5.99935 10.7036ZM5.99935 2.75338C5.43483 2.75338 5.01145 3.20029 5.01145 3.74128C5.01145 4.3058 5.43483 4.72919 5.99935 4.72919C6.54034 4.72919 6.98725 4.3058 6.98725 3.74128C6.98725 3.20029 6.54034 2.75338 5.99935 2.75338ZM7.31655 8.72784V8.16333C7.31655 8.0222 7.17542 7.88107 7.03429 7.88107H6.75204V5.52892C6.75204 5.38779 6.61091 5.24666 6.46978 5.24666H4.9644C4.79975 5.24666 4.68214 5.38779 4.68214 5.52892V6.09343C4.68214 6.25809 4.79975 6.37569 4.9644 6.37569H5.24666V7.88107H4.9644C4.79975 7.88107 4.68214 8.0222 4.68214 8.16333V8.72784C4.68214 8.89249 4.79975 9.0101 4.9644 9.0101H7.03429C7.17542 9.0101 7.31655 8.89249 7.31655 8.72784Z",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }